export function getQueryObject (search) {
  return Array.from(new URLSearchParams(search))
    .reduce((query, arg) => {
      query[arg[0]] = arg[1]
      return query
    }, {})
}
